var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookMarkUnFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58724 7.23594L10.1852 2.00394C10.2609 1.85253 10.3772 1.72517 10.5211 1.63616C10.6651 1.54715 10.831 1.5 11.0002 1.5C11.1695 1.5 11.3354 1.54715 11.4793 1.63616C11.6233 1.72517 11.7396 1.85253 11.8152 2.00394L14.4132 7.23594L20.2212 8.07994C20.3888 8.10317 20.5464 8.17303 20.6761 8.28155C20.8058 8.39007 20.9024 8.53288 20.9549 8.69367C21.0073 8.85446 21.0135 9.02676 20.9727 9.19089C20.932 9.35503 20.8458 9.5044 20.7242 9.62194L16.5222 13.6919L17.5142 19.4419C17.6412 20.1799 16.8612 20.7419 16.1942 20.3939L11.0002 17.6779L5.80524 20.3939C5.13924 20.7429 4.35924 20.1799 4.48624 19.4409L5.47824 13.6909L1.27624 9.62094C1.15522 9.50332 1.06964 9.3541 1.0292 9.19026C0.988768 9.02641 0.99511 8.85451 1.04751 8.69409C1.0999 8.53367 1.19625 8.39116 1.32561 8.28277C1.45496 8.17439 1.61212 8.10446 1.77924 8.08094L7.58724 7.23594Z",
    stroke: "#333333",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMarkUnFilled);
export default __webpack_public_path__ + "static/media/BookMarkUnFilled.179ee322c59728622536d767d0b91d00.svg";
export { ForwardRef as ReactComponent };